


import screen1 from "./screen1.jpeg";
import screen2 from "./screen2.jpeg"
import screen3 from "./screen3.jpeg"
import screen4 from "./screen4.jpeg"
import screen5 from "./screen5.jpeg"
import screen6 from "./screen6.jpeg"
import diagram from "./diagram.png"
import pic from "./pic.png"

const project_data = {
    tittle:"IOT monitoring Android and IOS app",
    source:"https://github.com/juanda2222/user_manager",
    website:"https://github.com/juanda2222/user_manager",
    abstract:"An application created using React Native and rest services in Google Cloud. The application uses Google Sign in and it connects to the data collected on a SQL server hosted on Google Cloud. The application can control binary actuators connected to the backend through mqtt and can display on real time data reported to the server",
    hashtags:["node", "react-native", "sql", "gcloud", "mqtt"],
    prev_image_index:1,
    images:[
        {
            caption:"Measure screen of the application", 
            image:screen1
        },
        {
            caption:"Introduction screen of the app", 
            image:screen2
        },
        {
            caption:"Control screen of the app", 
            image:screen3
        },
        {
            caption:"Side Menu", 
            image:screen4
        },
        {
            caption:"Home screen", 
            image:screen5
        },
        {
            caption:"Error screen", 
            image:screen6
        },
        {
            caption:"General diagram of the functional components of the system", 
            image:diagram
        },
        {
            caption:"Real case scenario of the System", 
            image:pic
        }
    ]
}

export default project_data

